import React, { useState } from 'react';
import { Select } from 'antd';

import StatementInputs from './statement.inputs';
import {
  DEFAULT_LAYOUT,
  Input, LAYOUTS, Rule,
} from '../../../../store/modules/rules';
import getStatement from './utils/getStatement';
import { useActions } from '../../../providers/actions-provider/actions.context';
import WithActionsContainer from './with.actions.container';
import SetInputs from './set.inputs';

type IStatementRuleProps = {
  rule: Rule;
  // direction?: 'column' | 'row';
  // eslint-disable-next-line
  onChange: (value: any, rule: Rule, input: Input | null) => void,
  onStatementTypeChange: (type: string, rule: Rule) => void,
  index: number,
  target: string;
};

const StatementRule = (
  {
    rule,
    onChange,
    onStatementTypeChange,
    index,
    target,
  }: IStatementRuleProps,
): JSX.Element | null => {
  const { userActions, ruleActions } = useActions();
  const statements = ruleActions.getTargetStatements(target);
  const [selected, setSelected] = useState(getStatement(
    rule.name, statements,
  ));
  const layout = selected?.inputsLayout || DEFAULT_LAYOUT;
  const parts = layout.split('-');
  const containerDirection = LAYOUTS[parts[0]];
  const contentDirection = LAYOUTS[parts[1]];

  const handleStatementChange = (value: string) => {
    const statement = getStatement(
      value, statements,
    );
    setSelected(statement);

    if (statement) {
      onStatementTypeChange(value, rule);
    }
  };
  const handleInfoClick = () => {
    if (selected) {
      userActions.getHelp(selected.help);
    }
  };

  return (
    <WithActionsContainer
      onDelete={() => ruleActions.deleteRule(rule, target)}
      containerExtraClassNames={['rule-statement-container']}
      overStyle={{ backgroundColor: '#E5E0FF' }}
      index={index}
      onInfoClick={selected && selected.help ? handleInfoClick : undefined}
      active={rule.active}
      onActiveChange={() => ruleActions.changeActive(rule, target)}
    >
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <Select
          style={{ width: 250 }}
          onChange={handleStatementChange}
          placeholder="Select Statement"
          defaultValue={selected?.name}
          options={statements}
        />
        {rule.name === 'set' ? (
          <SetInputs
            rule={rule}
            inputs={selected?.inputs}
            onChange={onChange}
          />
        ) : (
          <StatementInputs
            rule={rule}
            containerDirection={containerDirection}
            inputs={selected?.inputs}
            onChange={onChange}
            contentDirection={contentDirection}
          />
        )}
      </div>
    </WithActionsContainer>
  );
};

export default StatementRule;
